import React, { Component, lazy, Suspense } from 'react';
import {
  Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles, createMuiTheme } from '@material-ui/core/styles';
import Fetch from './Fetch';
import LoginForm from './LoginForm';
import history from './history';
import jwt from 'jsonwebtoken';
import { Button, Grid, Icon, MenuItem, Box } from '@material-ui/core';
import Constantes from './Constantes';

const Accueil = lazy(() => import('./Accueil'));
const Clients = lazy(() => import("./Clients"));
const Stock = lazy(() => import('./Stock'));
const Pots = lazy(() => import('./Pots'));
const Soum = lazy(() => import('./Soum'));
const CPU = lazy(() => import('./CPU'));
const Chat = lazy(() => import('./Chat'));
const MonCompte = lazy(() => import('./MonCompte'));
const Parametre = lazy(() => import('./Parametre'));
const PlanningBarman = lazy(() => import('./PlanningBarman'));
const Cafe = lazy(() => import('./Cafe'));
const Hook = lazy(() => import('./HookCourse'));

const drawerWidth = 240;

const theme = createMuiTheme();
const useStyles = {
  root: {
    display: 'flex',
    height: '100vh'
  },
  rootDeco: {
    backgroundColor: 'rgba(255,181,81,0.1) ',
    boxShadow: '0 0 30px rgba(255,181,81,0.8) inset',
    display: 'flex',
    height: '100vh'
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  lien: {
    backgroundColor: 'rgb(50,50,50,0.1)'
  },
  button: {
    lineHeight: 1,
    backgroundColor: 'rgba(255,206,28,0.87)',
    color: 'black',
    "&:hover": {
      backgroundColor: 'rgba(255,206,28,1)'
    }
  },
};

class AuthButton extends Component {

  render() {
    const { authenticate, foncConnect, foncDeco, classes } = this.props;

    return authenticate ? (
      <div>
        <Button
          variant="contained"
          size="small"
          className={classes.button}
          onClick={foncDeco} startIcon={<div className={"mdi mdi-logout"} />}>
          Déconnecter
          </Button>
      </div >
    ) : (
        <LoginForm className="LoginForm" submit={foncConnect} />
      )
  }
}

function PrivateRoute({ comp: Component, authenticate, path, children }) {

  let authenticateComp = authenticate || typeof localStorage.getItem('token') === 'string';

  if (authenticateComp) {
    const tokenDecode = jwt.decode(localStorage.getItem('token'));
    authenticateComp = tokenDecode.droits.filter(item => item.to === path).length > 0
  }

  return (
    <Route
      force={true}
      render={props =>
        authenticateComp ? (
          <Component {...props} />
        )
          :
          (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location }
              }}
            />
          )
      }
    />
  );
}



class ResponsiveDrawer extends Component {

  state = {
    mobileOpen: false,
    authenticate: false,
    menus: [
      { _id: 1, to: "/", libelle: 'Accueil', auth: false },
    ],
    lettres: [],
    konami: false
  }


  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  setAuthenticate(boolAuth, menus) {
    this.setState({ authenticate: boolAuth, menus });
  }

  login = () => {
    const token = localStorage.getItem('token');

    if (token) {
      const tokenDecode = jwt.decode(token);

      localStorage.setItem('idCompte', tokenDecode.userId);

      const expire = new Date(tokenDecode.exp * 1000) < new Date();
      if (!expire) {
        this.setAuthenticate(true, tokenDecode.droits);
      } else {
        console.error('Token expiré');
        console.error("Connecté...:", new Date(tokenDecode.iat * 1000));
        console.error("Expire.....:", new Date(tokenDecode.exp * 1000));
      }
    }
  }

  signout = () => {
    this.setAuthenticate(false, [{ to: "/", libelle: 'Home', auth: false }]);
    history.push('/login');
    localStorage.clear();
  }

  constructor() {
    super();
    Fetch.setFonctionDeco(this.signout);
    this.konamiChaine1 = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65].join('/');
    this.konamiChaine2 = [38, 38, 40, 40, 37, 39, 37, 39, 98, 97].join('/');
  }



  onKeyUp = (e) => {

    this.setState(state => {

      let lettres = state.lettres;
      lettres.push(e.keyCode);

      let { konami } = this.state;

      if (lettres.length > 10) {
        lettres = lettres.slice(1);
      }

      if (lettres.join('/') === this.konamiChaine1 || lettres.join('/') === this.konamiChaine2) {
        lettres = [];
        konami = true;
      }
      return { lettres, konami }
    })

  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onKeyUp);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.onKeyUp);
    if (typeof localStorage.getItem('token') === 'string') {
      this.login();
    }
  }


  render() {

    const { container, classes } = this.props;
    const { authenticate, mobileOpen, menus } = this.state;
    const { handleDrawerToggle, login, signout } = this;

    const drawer = (
      <div>
        <div className={classes.toolbar} />
        <Divider />
        {
          menus.map((item, index) =>
            (!item.auth || authenticate) &&
            <MenuItem button key={index}
              className={(window.location.pathname === item.to || item.to === this.state.lien) ? classes.lien : ''}
              onClick={() => {
                history.push(item.to);
                this.setState({ lien: item.to });
                if (mobileOpen) {
                  handleDrawerToggle();
                }
              }}>

              <Box component="div" >
                <Icon className={item.icone + " mdi_menu"} />
              </Box>

              <ListItemText>
                {item.libelle}
              </ListItemText>
            </MenuItem>
          )
        }
      </div >
    );

    return (
      <Router history={history} >

        {
          authenticate &&
          <div className={classes.root}>

            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>

                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                >
                  <AuthButton authenticate={authenticate}
                    foncConnect={login}
                    foncDeco={signout}
                    classes={classes}
                  />
                </Grid>

              </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Hidden mdUp implementation="css">
                <Drawer
                  container={container}
                  variant="temporary"
                  anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                  ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                  }}
                >
                  {drawer}
                </Drawer>
              </Hidden>
              <Hidden smDown implementation="css">
                <Drawer
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                  variant="permanent"
                  open
                >
                  {drawer}
                </Drawer>
              </Hidden>
            </nav>
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <div >
                <Suspense fallback={
                  <div className="imageFondChargement"></div>
                }>
                  <Switch>
                    <PrivateRoute authenticate={authenticate} path="/users" comp={Clients} />
                    <PrivateRoute authenticate={authenticate} path="/produits" comp={Stock} />
                    <PrivateRoute authenticate={authenticate} path="/soum" comp={Soum} />
                    <PrivateRoute authenticate={authenticate} path="/pots" comp={Pots} />
                    <PrivateRoute authenticate={authenticate} path="/typeproduits" comp={Parametre} />
                    <PrivateRoute authenticate={authenticate} path="/cpu" comp={CPU} />
                    <PrivateRoute authenticate={authenticate} path="/chat" comp={Chat} />
                    <PrivateRoute authenticate={authenticate} path="/compte" comp={MonCompte} />
                    <PrivateRoute authenticate={authenticate} path="/planningbarman" comp={PlanningBarman} />
                    <PrivateRoute authenticate={authenticate} path="/cafe" comp={Cafe} />
                    <PrivateRoute path="/hook" comp={Hook} />

                    <Route path="/" authenticate={authenticate}>
                      <Accueil authenticate={authenticate} />
                    </Route>
                  </Switch>
                </Suspense>
              </div>

              {this.state.konami &&
                <div className="konami" onClick={() => this.setState({ konami: false })}>

                  <div className="messageFelicitation">
                    <h3>  Félicitations, tu as gagné mon respect qui vaut 0 BN !!! </h3>
                  </div>

                  <div className="signatureGecko">
                    Little Gecko
                  </div>
                  <div>
                    <img alt="gecko"
                      className="imageKonami"
                      src={Constantes.url + "image/gecko2.gif"}>
                    </img>

                  </div>
                </div>
              }
            </main>
          </div>
        }

        {
          !authenticate &&
          <div className={classes.rootDeco}>

            <Grid container direction="column" alignItems="center" justify="center" spacing={0}>
              <Grid item>

                <div className="imageAccueil"></div>
              </Grid>

              <Grid item>
                <div className="divAccueilConnexion">
                  Bienvenue sur votre application du SOUM
                </div>
              </Grid>
              <Grid item>
                <AuthButton authenticate={authenticate}
                  foncConnect={login}
                  foncDeco={signout}
                />
              </Grid>
            </Grid>
          </div>
        }

      </Router >
    );
  }
}

const StyledResponsiveDrawer = withStyles(useStyles)(ResponsiveDrawer);

export default StyledResponsiveDrawer;

